import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const ResetPasswordRedirect = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const token = params.get('token');

    console.log("TOKEN URL:", token); // 👈 DEBUG

    if (!token) {
      alert("Token no encontrado");
      return;
    }

    // 🔥 guardar token correcto
    localStorage.setItem('reset_token', token);

    // 🔥 redirigir correctamente
    navigate('/PasswordChange');
  }, [navigate]);

  return <p>Redirigiendo...</p>;
};

export default ResetPasswordRedirect;